import * as React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Suspense } from 'react';
// import common from '@/common/wx'
import Routers from './routerMap';
import intl from 'react-intl-universal';
import LanguageChange from '@/views/component/LanguageChange';
// 引入redux
import store from '@/redux/store';
import { connect } from 'react-redux';
import { setLocalStorage, getLocalStorage } from '@/utils/utils';
import { config } from '@/lib/config';
import history from '@/lib/history.js';
import { setCookie } from '../utils/utils';

const locales = {
  'en': require('@/language/en.json'),
  'zh-CN': require('@/language/zh_CN.json'),
  'zh-TW': require('@/language/zh_TW.json'),
};

class RouterComponent extends React.Component<any, any> {
  public constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    document.title = locales[store.getState().changeLang.lang].webTitle;
    if (window.location.hash.split('#')[1] !== '/login'
      && window.location.hash.split('#')[1] !== '/weChatLogin'
      && window.location.hash.split('#')[1] !== '/bindPhone'
      && window.location.hash.split('#')[1].indexOf('/weChatLogin') === -1) {
      setCookie('redirectPath', window.location.hash.split('#')[1]);
      setCookie('redirectParam', window.location.search);
    }
    if (window.location.hash.split('#')[1].indexOf('/productDetail') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productDetailTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productCompute') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productComputeTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productHealthInform') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productHealthInformTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productTerms') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productTermsTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productDisclaimer') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productDisclaimerTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productBuy') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productBuyTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/productEnsure') !== -1) {
      document.title = locales[store.getState().changeLang.lang].productEnsureTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/payResult') !== -1) {
      document.title = locales[store.getState().changeLang.lang].payResultTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/myOrder') !== -1) {
      document.title = locales[store.getState().changeLang.lang].myOrderTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/healthExamFail') !== -1) {
      document.title = locales[store.getState().changeLang.lang].healthExamFailTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/login') !== -1) {
      document.title = locales[store.getState().changeLang.lang].loginTitle;
    } else if (window.location.hash.split('#')[1].indexOf('/bindPhone') !== -1) {
      document.title = locales[store.getState().changeLang.lang].bindPhoneTitle;
    } else {
      document.title = locales[store.getState().changeLang.lang].webTitle;
    }
    history.listen((route: any) => {
      if (route.location.pathname !== '/login'
        && route.location.pathname !== '/weChatLogin'
        && route.location.pathname !== '/bindPhone'
        && route.location.pathname.indexOf('/weChatLogin') === -1) {
        setCookie('redirectPath', route.location.pathname);
        setCookie('redirectParam', route.location.search);
      }
      if (route.location.pathname.indexOf('/productDetail') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productDetailTitle;
      } else if (route.location.pathname.indexOf('/productCompute') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productComputeTitle;
      } else if (route.location.pathname.indexOf('/productHealthInform') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productHealthInformTitle;
      }  else if (route.location.pathname.indexOf('/productTerms') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productTermsTitle;
      } else if (route.location.pathname.indexOf('/productDisclaimer') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productDisclaimerTitle;
      } else if (route.location.pathname.indexOf('/productBuy') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productBuyTitle;
      } else if (route.location.pathname.indexOf('/productEnsure') !== -1) {
        document.title = locales[store.getState().changeLang.lang].productEnsureTitle;
      } else if (route.location.pathname.indexOf('/payResult') !== -1) {
        document.title = locales[store.getState().changeLang.lang].payResultTitle;
      } else if (route.location.pathname.indexOf('/myOrder') !== -1) {
        document.title = locales[store.getState().changeLang.lang].myOrderTitle;
      } else if (route.location.pathname.indexOf('/healthExamFail') !== -1) {
        document.title = locales[store.getState().changeLang.lang].healthExamFailTitle;
      } else if (route.location.pathname.indexOf('/login') !== -1) {
        document.title = locales[store.getState().changeLang.lang].loginTitle;
      } else if (route.location.pathname.indexOf('/bindPhone') !== -1) {
        document.title = locales[store.getState().changeLang.lang].bindPhoneTitle;
      } else {
        document.title = locales[store.getState().changeLang.lang].webTitle;
      }
    });
    const rootDiv = document.getElementById('root');
    if (rootDiv) {
      rootDiv.setAttribute('data-platformCode', config().platformCode);
    }
    const scrollTop = Number(getLocalStorage('scrollTop'));
    setTimeout(() => {
      if (scrollTop) {
        window.scrollTo(0, scrollTop);
      }
    }, 500);
    this.loadLocales();
    if (window.location.href.indexOf('STATE#/weChatLogin') > 0) {
      const reg = new RegExp("(^|&)code=([^&]*)(&|$)");
      const params = ('?' + window.location.href.split("?")[1]).substr(1).match(reg);
      if (params !== null) {
        window.location.href = `${window.location.origin}/#/weChatLogin/?code=${params[2]}`;
      }
    }
  }

  public loadLocales() {
    // react-intl-universal 是单例模式, 只应该实例化一次
    intl.init({
      currentLocale: store.getState().changeLang.lang, // TODO: determine locale here
      locales,
    });
  }

  public render() {
    return (
        <HashRouter>
          <Switch>
            <Suspense fallback={<div>Loading...</div>}>
            <LanguageChange/>
            {
              Routers.map((item: any, index: string) => {
                return (
                  <Route
                    key={ index }
                    path={ item.path }
                    exact={ true }
                    component={ item.component }/>
                )
              })
            }
            </Suspense>
          </Switch>
        </HashRouter>
    )
  }
}

function mapStateToProps(state) {
  return {
    state,
  }
}

export default connect(
  mapStateToProps,
)(RouterComponent);
